import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Loader from "components/Loader";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/profile";

const OrganisationContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(actions.getOrgs());
  }, [dispatch]);

  const orgs = profile.allProfiles?.orgs || [];

  return (
    <Card sx={{ width: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox display="flex" alignItems="center" gap={2}>
          <MDBox
            display="flex" justifyContent="center" alignItems="center"
            width="4rem" height="4rem" variant="gradient" bgColor="primary"
            color="white" shadow="md" borderRadius="xl"
          >
            <Icon fontSize="medium" color="inherit">business</Icon>
          </MDBox>
          <MDTypography variant="h5">Organisations</MDTypography>
        </MDBox>
        <MDButton color="primary" onClick={() => navigate("/users/organisation/add-organisation")}>
          + Add Organisation
        </MDButton>
      </MDBox>

      <MDBox p={3}>
        {profile.loading ? (
          <Loader />
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {orgs.map((org, idx) => (
                <tr key={org.id ?? idx}>
                  <td>{idx + 1}</td>
                  <td>{org.name || org.Name || "—"}</td>
                  <td>{org.email || org.Email || "—"}</td>
                  <td>{org.phone || org.Phone || "—"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!profile.loading && orgs.length === 0 && (
          <p className="text-center p-5">No organisations found.</p>
        )}
      </MDBox>
    </Card>
  );
};

export default OrganisationContainer;
